import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useIdentificationChartsDataContext } from './hooks/useIdentificationChartsDataContext';

export const Apgar5Minutes = () => {
    const { chartData } = useIdentificationChartsDataContext();


    return (
        <SimpleBars
            title={'Indice de Apgar 5 minutos'}
            horizontal={false}
            subtitles={chartData?.apgar5Minutes?.map((item) => item.description)}
            values={chartData?.apgar5Minutes?.map((item) => item.total  ||  0)}
        />
    );
};
